/* collection-intro.js
   Drives every [data-intro-root] rendered by snippets/collection-intro.liquid.

   - Clamps the intro copy to 3 lines (via CSS) and only shows "Read more" when
     the copy actually overflows.
   - "Read more" opens a LEFT slide-out drawer with a runtime clone of the same
     copy (the full text already sits in the page HTML for crawlers — nothing is
     fetched), plus the collection title, product count, and a "Shop the
     collection" CTA that closes the drawer and scrolls to the product grid.
   - De-dupes: the copy can be emitted by both the banner section and a
     custom-liquid block on the same page. We keep the FIRST instance and hide
     the rest so the customer only ever sees it once.
*/
(function () {
  "use strict";

  // Where "Shop the collection" scrolls to — first match wins.
  var GRID_SELECTORS = [".cc-collection-products", "#filter-results", "#product-grid"];

  function gridTarget() {
    for (var i = 0; i < GRID_SELECTORS.length; i++) {
      var el = document.querySelector(GRID_SELECTORS[i]);
      if (el) return el;
    }
    return null;
  }

  function bindOne(root) {
    if (root.dataset.introBound === "1") return;
    root.dataset.introBound = "1";

    var text   = root.querySelector("[data-intro-text]");
    var btn    = root.querySelector("[data-intro-more]");
    var drawer = root.querySelector("[data-intro-modal]");
    var body   = root.querySelector("[data-intro-body]");
    var shop   = root.querySelector("[data-intro-shop]");
    if (!text || !btn || !drawer || !body) return;

    // Hoist the drawer to <body> so no clipped/transformed banner ancestor hides
    // it and the fixed overlay covers the whole viewport.
    if (drawer.parentNode !== document.body) document.body.appendChild(drawer);

    function refreshButton() {
      // Show "Read more" only when the copy is actually clamped (overflows 3 lines).
      // The button keeps its line in every state (visibility, not display), so
      // revealing it after load never pushes the content below it down (CLS).
      var clamped = text.scrollHeight > text.clientHeight + 2;
      btn.hidden = false;
      btn.classList.remove("is-pending");
      btn.style.visibility = clamped ? "" : "hidden";
      btn.setAttribute("aria-hidden", clamped ? "false" : "true");
      btn.tabIndex = clamped ? 0 : -1;
    }

    function openDrawer() {
      body.innerHTML = text.innerHTML;
      drawer.hidden = false;
      document.documentElement.classList.add("intro-drawer-open");
      // Next frame so the slide-in transition runs from the off-screen state.
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { drawer.classList.add("is-open"); });
      });
    }

    function closeDrawer() {
      drawer.classList.remove("is-open");
      document.documentElement.classList.remove("intro-drawer-open");
      var panel = drawer.querySelector(".intro-drawer__panel");
      var done = function () {
        drawer.hidden = true;
        if (panel) panel.removeEventListener("transitionend", done);
      };
      if (panel) {
        panel.addEventListener("transitionend", done);
        // Fallback if transitionend doesn't fire (reduced motion, etc.).
        setTimeout(done, 400);
      } else {
        drawer.hidden = true;
      }
    }

    btn.addEventListener("click", openDrawer);
    drawer.addEventListener("click", function (e) {
      if (e.target.hasAttribute("data-intro-close")) closeDrawer();
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && !drawer.hidden) closeDrawer();
    });
    if (shop) {
      shop.addEventListener("click", function () {
        closeDrawer();
        var target = gridTarget();
        if (target) {
          target.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      });
    }
    window.addEventListener("resize", refreshButton);
    refreshButton();
  }

  function init() {
    var roots = document.querySelectorAll("[data-intro-root]");
    if (!roots.length) return;
    // Keep the first instance; hide any later duplicates (same copy from a second
    // source) so the page never shows the intro twice.
    for (var i = 1; i < roots.length; i++) {
      roots[i].hidden = true;
      roots[i].dataset.introBound = "1";
    }
    bindOne(roots[0]);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
